import React from 'react';
import SetProductDivider from '@setproduct-ui/core/Divider';

const Divider = (props) => <SetProductDivider {...props} />;

export default Divider;
